import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierRevenueReport extends Layout {
    excludabletextbox1: ExcludableTextbox;
    excludabletextbox2: ExcludableTextbox;
    sourceCarrierRevenue: DataSource;
    switchMargin: Switch;
    switchReportType: Switch;
    textbox1: Textbox;
    textbox2: Textbox;
    textboxInclude: Textbox;
    textboxSortBy: Textbox;
}
